import { apiSlice } from "./authApi";

export const patientLabsApiSlice =  apiSlice.injectEndpoints({
    endpoints: (builder) =>({
        getLabsByPatientId: builder.query({
            query:({ patientId, page = 1, pageSize = 10}) =>({
                url: `/patients/${patientId}/labs/`,
                method: "GET",
                params: {page, pageSize},
            }),
            providesTags: (result, error, {patientId}) => [
                {type: "PatientLab", patientId}
            ],
            transformResponse: response => ({
                results: response.results,
                count: response.count
            }),
            keepUnusedDataFor: 5,
        }),

        getPatientLab: builder.query({
            query: ({patientId, labId}) => ({
                url: `/patients/${patientId}/labs/${labId}/`,
                method: "GET",
            }),
            providesTags: (result, error, {labId}) => [
                {type: "PatientLab", labId}
            ],
        }),

        createPatientLab: builder.mutation({
            query: ({ patientId, newPatientLab}) => ({
                url: `/patients/${patientId}/labs/`,
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                },
                body: newPatientLab,
            }),
            invalidatesTags: (result, error, {patientId}) => [
                { type: "PatientLab", patientId}
            ],

        }),

        updatePatientLab: builder.mutation({
            query: ({ patientId, labId, ...update }) => ({
                url: `/patients/${patientId}/labs/${labId}/`,
                method: "PATCH",
                body: update,
                headers: {
                    "Content-Type": "application/json",
                },
            }),
            invalidatesTags: (result, error, { labId }) => [
                { type: "PatientLab", labId },
            ],
        }),

        deletePatientLab: builder.mutation({
            query: ({patientId, labId}) => ({
                url: `/patients/${patientId}/labs/${labId}/`,
                method: "DELETE",
            }),
            invalidatesTags: (result, error, {labId}) => [
                {type: "PatientLab", labId}
            ]
        })

    })
});



export const {
    useGetLabsByPatientIdQuery,
    useGetPatientLabQuery,
    useCreatePatientLabMutation,
    useUpdatePatientLabMutation,
    useDeletePatientLabMutation,
} = patientLabsApiSlice;